//sadnand_gadwal

// Presales Incentive Plan
export const GET_PRESALES_INCENTIVE_PLAN = "GET_PRESALES_INCENTIVE_PLAN";
export const GET_PRESALES_INCENTIVE_PLAN_EXPORT =
  "GET_PRESALES_INCENTIVE_PLAN_EXPORT";
export const GET_PRESALES_INCENTIVE_PLAN_DETAIL =
  "GET_PRESALES_INCENTIVE_PLAN_DETAIL";

// PreSales New
export const GET_LEAD = "GET_LEAD";
export const GET_LEAD_EXPORT = "GET_LEAD_EXPORT";
export const GET_LEAD_DETAIL = "GET_LEAD_DETAIL";
export const GET_USER_FOR_LEAD_ASSIGN = "GET_USER_FOR_LEAD_ASSIGN";
export const GET_COUNTRY_CODE = "GET_COUNTRY_CODE";
export const GET_PROJECT = "GET_PROJECT";
export const GET_SOURCE_CATEGORY = "GET_SOURCE_CATEGORY";
export const GET_SOURCE = "GET_SOURCE";
export const GET_SUB_SOURCE = "GET_SUB_SOURCE";
export const GET_LEAD_CATEGORY = "GET_LEAD_CATEGORY";
export const GET_CRM_LEAD_STATUS_COUNT = "GET_CRM_LEAD_STATUS_COUNT";
export const GET_LEAD_FILTER_PROJECT = "GET_LEAD_FILTER_PROJECT";
export const GET_LEAD_FILTER_SOURCE = "GET_LEAD_FILTER_SOURCE";
export const GET_LEAD_OWNER_FILTER_LIST = "GET_LEAD_OWNER_FILTER_LIST";
export const GET_LEAD_SITE_VISIT = "GET_LEAD_SITE_VISIT";
export const GET_LEAD_PROFILE = "GET_LEAD_PROFILE";
export const GET_CITY = "GET_CITY";
export const GET_CUSTOMER_CURRENT_LIVING = "GET_CUSTOMER_CURRENT_LIVING";
export const GET_CUSTOMER_SUITABLE_TIME = "GET_CUSTOMER_SUITABLE_TIME";
export const GET_CUSTOMER_CONSTRUCTION_PLANNING =
  "GET_CUSTOMER_CONSTRUCTION_PLANNING";
export const GET_CUSTOMER_BUDGET = "GET_CUSTOMER_BUDGET";
export const GET_CRM_DIMENSION = "GET_CRM_DIMENSION";
export const GET_CUSTOMER_INCOME = "GET_CUSTOMER_INCOME";
export const GET_CUSTOMER_WORK_EXPERIENCE = "GET_CUSTOMER_WORK_EXPERIENCE";
export const GET_CUSTOMER_WORK_FUNCTION = "GET_CUSTOMER_WORK_FUNCTION";
export const GET_CUSTOMER_WORK_SECTOR = "GET_CUSTOMER_WORK_SECTOR";
export const GET_CUSTOMER_ORGANIZATION = "GET_CUSTOMER_ORGANIZATION";
export const GET_EMPLOYMENT_TYPE = "GET_EMPLOYMENT_TYPE";
export const GET_CUSTOMER_PURCHASE_REASON = "GET_CUSTOMER_PURCHASE_REASON";
